<div class="bgColor">
  <div class="container-fluid attendance-container">
    <div class="row">
      <div class="attendance-left-col col-md-6">
        <div class="attendance-left">
          <h2 class="title-head">Attendance</h2>
          <div class="d-flex">
            <!-- <span class="date-icon" (click)="changeDate(-1)"><i class="fa-solid fa-angle-left"></i></span> -->
            <span class="d-flex">
              <!-- <p-calendar [(ngModel)]="currentdate" [dateFormat]="date" id="attendance-date" [iconDisplay]="'input'"
                touchUI="true" [showIcon]="true" styleClass="custom-calendar" inputId="icondisplay"
                (onSelect)="onDateChange($event)">
              </p-calendar> -->
            </span>




            <!-- <span class="date-icon" (click)="changeDate(1)"><i class="fa-solid fa-angle-right"></i></span> -->
          </div>
        </div>
      </div>
      <div class="attendance-right-col col-md-4">
        <!-- <div class="attendance-right">
          <div class="status-dropdown">
            <img
              src="../../../../../../assets/img/Attendence Icon/twemoji_flag-india.svg"
              alt="Flag Icon"
            />
            <select class="flag">
              <option value="in">IN</option>
            </select>
          </div>
          <button class="report-button">Attendance Report</button>
          <button class="report-button primary">Attendance Report</button>
        </div> -->
      </div>
      <div class="col-md-2 text-end">
        <button class="btn attendance-calendar" (click)="buttonNameOnClick()">
          {{ buttonName }}
        </button>
        <!-- <button class="btn holiday-master">Holiday Master</button> -->
      </div>
    </div>
  </div>

  <form [formGroup]="searchForm">

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-4" *ngIf="role != 4">

          <ng-select [items]="employeeList" bindLabel="displayName" bindValue="id" formControlName="employee_id"
            placeholder="Select Employee" [clearable]="false" (change)="onFilterChange()">
          </ng-select>

        </div>
        <div class="col-md-4">
          <select id="month" class="form-select" formControlName="month" (change)="onFilterChange()">
            <option value="" disabled>Month</option>
            <option *ngFor="let option of months" [value]="option.value">{{ option.label }}</option>
          </select>
        </div>
        <div class="col-md-4 d-flex align-items-center">
          <div class="w-50">
            <select id="year" class="form-select" formControlName="year" (change)="onFilterChange()">
              <option value="" disabled>Year</option>
              <option *ngFor="let option of years" [value]="option.value">{{ option.label }}</option>
            </select>
          </div>
          <div class="w-50">
            <div class="filter-group">
              <div class="form-group">
                <div class="d-flex justify-content-between align-items-center">
                  <!-- <i class="fa fa-filter me-1" aria-hidden="true"></i> -->
                  <select id="attendanceFilter" class="form-select attendance-filter-list"
                    (change)="onFilterSelected($event)">
                    <option value="">All</option>
                    <option value="On Time">On Time</option>
                    <option value="Absent">Absent</option>
                    <!-- <option value="Early Check-In">Early Check-In</option> -->
                    <option value="Late Check-In">Late Check-In</option>
                  </select>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>

  </form>

  <div class="container-fluid mt-0 attendance-card-container">
    <div class="row g-3">
      <!-- Present Summary Card -->
      <!-- <div class="col-md-4">
        <div class="card border-0 attendance-grid-card">
          <div
            class="p-2 d-flex justify-content-between align-items-center border-0"
          >
            <span class="mb-0"
              ><img
                src="../../../../../../assets/img/Attendence Icon/clipboard-text2.svg"
                alt=""
              /><span class="card-head"> Present Summary</span>
            </span>
            <span class="menu">...</span>
          </div>
          <div class="card-body">
            <div class="row text-center">
              <div class="col border-end">
                <p class="mb-1 attendance-grid-title">Overall</p>
                <h6>{{ totalTodayCount || 0 }}</h6>
                <div class="compare">
                  <span
                    >{{
                      (totalTodayCount || 0) - (totalYesterdayCount || 0)
                    }}
                    vs </span
                  ><span>Yesterday</span>
                </div>
              </div>
              <div class="col border-end">
                <p class="mb-1 attendance-grid-title">Late Check In</p>
                <h6>{{ todayLateCheckInCount || 0 }}</h6>
                <div class="compare">
                  <span
                    >{{
                      (todayLateCheckInCount || 0) -
                        (yesterdayLateCheckInCount || 0)
                    }}
                    vs </span
                  ><span>Yesterday</span>
                </div>
              </div>
              <div class="col">
                <p class="mb-1 attendance-grid-title">Early Check In</p>
                <h6>{{ todayEarlyCheckInCount || 0 }}</h6>
                <div class="compare">
                  <span
                    >{{
                      (todayEarlyCheckInCount || 0) -
                        (yesterdayEarlyCheckInCount || 0)
                    }}
                    vs </span
                  ><span>Yesterday</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- Not Present Summary Card -->
      <!-- <div class="col-md-4">
        <div class="card border-0 attendance-grid-card">
          <div
            class="p-2 d-flex justify-content-between align-items-center border-0"
          >
            <span class="mb-0"
              ><img
                src="../../../../../../assets/img/Attendence Icon/clipboard-text2.svg"
                alt=""
              /><span class="card-head"> Not Present Summary</span>
            </span>
            <span class="menu">...</span>
          </div>
          <div class="card-body">
            <div class="row text-center">
              <div class="col border-end">
                <p class="mb-1 attendance-grid-title">Absence</p>
                <h6>{{ totalTodayAbsentCount || 0 }}</h6>
                <div class="compare">
                  <span
                    >{{
                      (totalTodayAbsentCount || 0) -
                        (totalYesterdayAbsentCount || 0)
                    }}
                    vs </span
                  ><span>Yesterday</span>
                </div>
              </div>
              <div class="col border-end">
                <p class="mb-1 attendance-grid-title">No Clock-In</p>
                <h6>0</h6>
                <div class="compare">
                  <span>-6 vs </span><span>Yesterday</span>
                </div>
              </div>
              <div class="col">
                <p class="mb-1 attendance-grid-title">No Clock Out</p>
                <h6>0</h6>
                <div class="compare">
                  <span>-6 vs </span><span>Yesterday</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- Away Summary Card -->
      <!-- <div class="col-md-4">
        <div class="card border-0 attendance-grid-card">
          <div
            class="p-2 d-flex justify-content-between align-items-center border-0"
          >
            <span class="mb-0"
              ><img
                src="../../../../../../assets/img/Attendence Icon/clipboard-text2.svg"
                alt=""
              /><span class="card-head"> Away Summary</span>
            </span>
            <span class="menu">...</span>
          </div>
          <div class="card-body">
            <div class="row text-center">
              <div class="col border-end">
                <p class="mb-1 attendance-grid-title">Day Off</p>
                <h6>0</h6>
                <div class="compare">
                  <span>+12 vs </span><span>Yesterday</span>
                </div>
              </div>
              <div class="col">
                <p class="mb-1 attendance-grid-title">Time Off</p>
                <h6>0</h6>
                <div class="compare">
                  <span>+12 vs </span><span>Yesterday</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>

  <!-- <div class="container-fluid attendance-filter">
    <div class="row">
      <div class="d-flex gap-2 align-items-center">
        

        <div class="input-group search-group">
          <span class="input-group-text bg-white search-group-icon">
            <i class="fa fa-search" aria-hidden="true"></i>
          </span>
          <input #searchInput type="text" class="form-control search-group-input" placeholder="Search here"
            aria-label="Search" [(ngModel)]="searchEmployees" (ngModelChange)="onSearchChange($event)" />
        </div>
      </div>
    </div>
  </div> -->

  <div class="container">
    <div class="row">
      <div class="d-flex justify-content-end">
        <app-table-export-import-button *ngIf="employees.length != 0" [tableId]="'menusTable'">
        </app-table-export-import-button>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="bg-table">
    <div class="container-fluid">
      <p-table id="menusTable" styleClass="p-datatable-gridlines my-2" [value]="employees"
        [tableStyle]="{ 'min-width': '60rem' }" [totalRecords]="totalRecords" [rows]="10"
        [rowsPerPageOptions]="[5, 10, 20]" [lazy]="true" [sortMode]="'multiple'">
        <ng-template pTemplate="header" class="header">
          <tr>
            <th scope="" class="tHead" pSortableColumn="employeecode">
              <img src="../../../../../../assets/img/Attendence Icon/user.svg" alt="" />
              Employee Name / ID
              <!-- <p-sortIcon field="employeecode"></p-sortIcon> -->
            </th>
            <th scope="" class="tHead" pSortableColumn="roledata.role">
              <img src="../../../../../../assets/img/Attendence Icon/Group 1171281106.svg" alt="" />
              Date
              <!-- <p-sortIcon field="roledata.role"></p-sortIcon> -->
            </th>
            <th scope="" class="tHead" pSortableColumn="checkintime">
              <i class="fa-regular fa-clock"></i> Clock-in & Out
              <!-- <p-sortIcon field="checkintime"></p-sortIcon> -->
            </th>
            <th scope="" class="tHead" pSortableColumn="overtimehours">
              <img src="../../../../../../assets/img/Attendence Icon/Vector-2.svg" alt="" />
              Overtime
              <!-- <p-sortIcon field="overtimehours"></p-sortIcon> -->
            </th>
            <th scope="" class="tHead" pSortableColumn="typeofwork">
              <img src="../../../../../../assets/img/Attendence Icon/Vector-1.svg" alt="" />
              Designation
              <!-- <p-sortIcon field="typeofwork"></p-sortIcon> -->
            </th>
            <th scope="" class="tHead" pSortableColumn="status">
              <img src="../../../../../../assets/img/Attendence Icon/Vector.svg" alt="" />
              Status
              <!-- <p-sortIcon field="status"></p-sortIcon> -->
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-employee>
          <tr *ngIf="attendanceData.length !== 0">
            <td>
              {{ employee.firstname }} {{ employee.lastname }} ({{
              employee.employeecode
              }})
            </td>
            <td>{{ employee.attendancedate | date: angularDateFormat}}</td>
            <td>
              <span class="time-start">{{
                employee.checkintime | date : "hh:mm a" : "UTC"
                }}</span>
              - {{ employee.totalhoursworked || "00:00" }} -
              <span class="time-end">{{
                employee.checkouttime
                ? (employee.checkouttime
                | date
                : "hh:mm
                a"
                : "UTC")
                : "00:00"
                }}</span>
            </td>
            <td>{{ employee.overtimehours }}</td>
            <td>{{ employee.Designation.name }}</td>
            <td>
              <button class="status">{{ employee.status }}</button>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <ngb-pagination *ngIf="employees.length != 0" [maxSize]="5" [collectionSize]="totalRecords"
        class="pagination-master" [(page)]="currentPage" [pageSize]="pageSize" [rotate]="true" [ellipses]="false"
        [boundaryLinks]="true" (pageChange)="handlePageChange($event)">
      </ngb-pagination>
    </div>
  </div>

  <div *ngIf="employees.length === 0" class="p-3 text-center">
    No records to show
  </div>
</div>